// src/sections/ContentGenerator.jsx — full replacement
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext.jsx';
import EscContentCreatorPro from '../EscContentCreatorPro.jsx';

export default function ContentGenerator() {
  const { activeTenant, isSuperadmin, adminMode } = useAuth();
  if (isSuperadmin && adminMode) return <Navigate to="/admin/users" replace />;

  return (
    <EscContentCreatorPro
      tenantId={activeTenant?.tenant_id}
    />
  );
}
